<p-dialog [visible]="visible" (visibleChange)="visibleChange.emit($event)" [modal]="true"
  header="Add Field Person" [draggable]="false" [resizable]="false"
  [style]="{ width: 'min(980px, 94vw)' }" [breakpoints]="{ '860px': '96vw' }"
  styleClass="master-create-dialog">
  <section class="master-dialog-body">
    <aside class="master-dialog-summary">
      <div class="summary-icon"><i class="pi pi-users"></i></div>
      <div><small>Field Work</small><h3>Create an operational person</h3>
        <p>Register internal, freelance, or supplier-provided people independently of HR workforce planning.</p></div>
      <div class="master-dialog-facts">
        <div><span>Worker number</span><strong>Generated on save</strong></div>
        <div><span>Source</span><strong>{{ form.sourceType || 'INTERNAL' }}</strong></div>
        <div><span>Payee</span><strong>{{ form.payablePartyType || 'Select payee' }}</strong></div>
      </div>
    </aside>

    <form class="master-dialog-form" (ngSubmit)="submit()">
      <div class="dialog-error master-wide-field" *ngIf="validationError || error">
        <i class="pi pi-exclamation-circle"></i><span>{{ validationError || error }}</span>
      </div>
      <p-inputGroup *ngIf="form.sourceType === 'INTERNAL'">
        <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
        <p-iftalabel><input id="fieldWorkerName" pInputText name="displayName" [(ngModel)]="form.displayName">
          <label for="fieldWorkerName">Display name *</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerSource" name="sourceType" [(ngModel)]="form.sourceType"
          [options]="sourceOptions" optionLabel="label" optionValue="value" appendTo="body" styleClass="w-full"
          (onChange)="sourceChanged()"></p-select><label for="fieldWorkerSource">Source type *</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-briefcase"></i></p-inputGroupAddon>
        <p-iftalabel><input id="fieldWorkerCategory" pInputText name="workerCategory" [(ngModel)]="form.workerCategory">
          <label for="fieldWorkerCategory">Worker category</label></p-iftalabel>
      </p-inputGroup>

      <p-inputGroup class="master-wide-field" *ngIf="form.sourceType === 'INTERNAL'">
        <p-inputGroupAddon><i class="pi pi-id-card"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerEmployee" name="hrEmployeeId" [(ngModel)]="form.hrEmployeeId"
          [options]="employeeOptions" optionLabel="label" optionValue="value" [filter]="true" [showClear]="true"
          appendTo="body" styleClass="w-full" (onChange)="employeeChanged($event.value)"></p-select>
          <label for="fieldWorkerEmployee">Optional HR employee link</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup class="master-wide-field" *ngIf="form.sourceType !== 'INTERNAL'">
        <p-inputGroupAddon><i class="pi pi-user"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerLaborer" name="laborerId" [(ngModel)]="form.laborerId"
          [options]="laborerOptions" optionLabel="label" optionValue="value" [filter]="true" appendTo="body"
          styleClass="w-full" (onChange)="laborerChanged($event.value)"></p-select>
          <label for="fieldWorkerLaborer">Individual laborer *</label></p-iftalabel>
        <p-button label="Create laborer" icon="pi pi-user-plus" [text]="true" (onClick)="createLaborer.emit()"></p-button>
      </p-inputGroup>
      <p-inputGroup class="master-wide-field" *ngIf="form.sourceType === 'SUPPLIER_WORKER'">
        <p-inputGroupAddon><i class="pi pi-building"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerSupplier" name="supplierCrmClientId"
          [(ngModel)]="form.supplierCrmClientId" [options]="supplierOptions" optionLabel="label" optionValue="value"
          [filter]="true" appendTo="body" styleClass="w-full" (onChange)="supplierChanged($event.value)"></p-select>
          <label for="fieldWorkerSupplier">Supplying CRM client *</label></p-iftalabel>
      </p-inputGroup>

      <p-inputGroup *ngIf="form.sourceType !== 'FREELANCE'">
        <p-inputGroupAddon><i class="pi pi-wallet"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerPayeeType" name="payablePartyType"
          [(ngModel)]="form.payablePartyType" [options]="payeeTypeOptions" appendTo="body" styleClass="w-full"
          (onChange)="form.payablePartyId = undefined"></p-select><label for="fieldWorkerPayeeType">Payee type *</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup *ngIf="form.sourceType !== 'FREELANCE'">
        <p-inputGroupAddon><i class="pi pi-address-book"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerPayee" name="payablePartyId" [(ngModel)]="form.payablePartyId"
          [options]="payeeOptions" optionLabel="label" optionValue="value" [filter]="true" appendTo="body"
          styleClass="w-full" (onChange)="payeeChanged($event.value)"></p-select><label for="fieldWorkerPayee">Payee *</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-home"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerHome" name="homeLocationId" [(ngModel)]="form.homeLocationId"
          appLazyLocationPicker optionLabel="name" optionValue="id" [filter]="true" [showClear]="true"
          appendTo="body" styleClass="w-full"></p-select><label for="fieldWorkerHome">Home location</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-map-marker"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerCurrent" name="currentLocationId" [(ngModel)]="form.currentLocationId"
          appLazyLocationPicker optionLabel="name" optionValue="id" [filter]="true" [showClear]="true"
          appendTo="body" styleClass="w-full"></p-select><label for="fieldWorkerCurrent">Current location</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup>
        <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
        <p-iftalabel><p-select inputId="fieldWorkerStatus" name="status" [(ngModel)]="form.status"
          [options]="statusOptions" appendTo="body" styleClass="w-full"></p-select><label for="fieldWorkerStatus">Status *</label></p-iftalabel>
      </p-inputGroup>
      <p-inputGroup class="master-wide-field">
        <p-inputGroupAddon><i class="pi pi-file-edit"></i></p-inputGroupAddon>
        <p-iftalabel><input id="fieldWorkerNotes" pInputText name="notes" [(ngModel)]="form.notes">
          <label for="fieldWorkerNotes">Notes</label></p-iftalabel>
      </p-inputGroup>
    </form>
  </section>
  <ng-template pTemplate="footer"><div class="master-dialog-footer">
    <p-button label="Reset" icon="pi pi-refresh" severity="secondary" [outlined]="true" (onClick)="reset()"></p-button>
    <span class="footer-spacer"></span>
    <p-button label="Cancel" icon="pi pi-times" severity="secondary" [outlined]="true" [disabled]="saving" (onClick)="close()"></p-button>
    <p-button label="Add person" icon="pi pi-user-plus" [loading]="saving" (onClick)="submit()"></p-button>
  </div></ng-template>
</p-dialog>
